// src/firebase/invoice/saveInvoice.ts
import { ref, push, set } from "firebase/database";
import { db } from "../firebaseConfig";
import { InvoiceData } from "../../models/invoice";

export const saveInvoice = async (invoice: InvoiceData) => {
	const trimmedInvoiceNumber = invoice?.invoiceNumber?.trim();
	if (!trimmedInvoiceNumber) {
		throw new Error("Invoice number is required.");
	}
	if (!Array.isArray(invoice?.items) || invoice.items.length === 0) {
		throw new Error("Invoice must include at least one item.");
	}

	try {
		const invoiceRef = ref(db, "invoices"); // Flat structure
		const newInvoiceRef = push(invoiceRef);
		await set(newInvoiceRef, {
			...invoice,
			invoiceNumber: trimmedInvoiceNumber
		});
		return newInvoiceRef.key;
	} catch (error) {
		console.error("Error saving invoice:", error);
		throw error;
	}
};
